import { IpAddressWhitelistIpCell } from '@/features/ip_address_whitelists/components/IpAddressWhitelistsTable/Columns/Cells/IpAddressWhitelistIpCell';
import { IpAddressWhitelistRowActionsCell } from '@/features/ip_address_whitelists/components/IpAddressWhitelistsTable/Columns/Cells/IpAddressWhitelistRowActionsCell';
import type { IpAddressWhitelistInlineFormValues } from '@/features/ip_address_whitelists/IpAddressWhitelistList/types';
import type { IpAddressWhitelistTableRow } from '@/features/ip_address_whitelists/type';
import { useTranslation } from '@/i18n';
import type { ColumnType } from 'antd/es/table/interface';
import classnames from 'classnames/bind';
import { useMemo } from 'react';
import type { Control } from 'react-hook-form';
import styles from './column.module.scss';

const cx = classnames.bind(styles);

export type UseIpAddressWhitelistsTableColumnsProps = {
  editingRowId: string | null;
  inlineFormControl: Control<IpAddressWhitelistInlineFormValues>;
  isInlineSaveDisabled: boolean;
  isEditingRestrict: boolean;
  isDeleteBlockedByRestriction: boolean;
  isAddModalOpen: boolean;
  onSaveInline: () => void;
  onCancelInline: () => void;
  onStartEdit: (row: IpAddressWhitelistTableRow) => void;
  onDeleteRow: (row: IpAddressWhitelistTableRow) => void | Promise<void>;
};

export const useIpAddressWhitelistsTableColumns = ({
  editingRowId,
  inlineFormControl,
  isInlineSaveDisabled,
  isEditingRestrict,
  isDeleteBlockedByRestriction,
  isAddModalOpen,
  onSaveInline,
  onCancelInline,
  onStartEdit,
  onDeleteRow,
}: UseIpAddressWhitelistsTableColumnsProps): ColumnType<IpAddressWhitelistTableRow>[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        title: t('ip_address_whitelist_table_column_ip'),
        dataIndex: 'ip_address',
        key: 'ip_address',
        className: cx('ip-address-column'),
        render: (_: unknown, row: IpAddressWhitelistTableRow) => (
          <IpAddressWhitelistIpCell
            row={row}
            editingRowId={editingRowId}
            inlineFormControl={inlineFormControl}
          />
        ),
      },
      {
        title: '',
        key: 'actions',
        width: '1%',
        className: cx('actions-column'),
        render: (
          _: unknown,
          row: IpAddressWhitelistTableRow,
          index: number
        ) => (
          <IpAddressWhitelistRowActionsCell
            row={row}
            rowIndex={index}
            editingRowId={editingRowId}
            isInlineSaveDisabled={isInlineSaveDisabled}
            isEditingRestrict={isEditingRestrict}
            isDeleteBlockedByRestriction={isDeleteBlockedByRestriction}
            isAddModalOpen={isAddModalOpen}
            onSaveInline={onSaveInline}
            onCancelInline={onCancelInline}
            onStartEdit={onStartEdit}
            onDeleteRow={onDeleteRow}
          />
        ),
      },
    ],
    [
      editingRowId,
      inlineFormControl,
      isInlineSaveDisabled,
      isAddModalOpen,
      isEditingRestrict,
      isDeleteBlockedByRestriction,
      onCancelInline,
      onDeleteRow,
      onSaveInline,
      onStartEdit,
      t,
    ]
  );
};
